import React from "react";
import {
  FaCameraRetro,
  FaUsers,
  FaBriefcase,
  FaBell,
  FaGlobe,
  FaCloudUploadAlt,
} from "react-icons/fa";

const features = [
  {
    icon: <FaCameraRetro className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Share your Art / Craft / Work",
    description:
      "Share photos and videos of your creative work with your peers, connections, employers and even fans, similar to Instagram.",
  },
  {
    icon: <FaUsers className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Connect with Collaborators ",
    description:
      "Get and stay connected with colleagues, peers, collaborators, and creative friends, similar to Facebook.",
  },
  {
    icon: <FaBriefcase className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Build Your Network",
    description: "Grow your professional network, similar to LinkedIn.",
  },
  {
    icon: <FaBell className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Reminders",
    description:
      "Never miss an important moment! Get notified about updates and events.",
  },
  {
    icon: <FaGlobe className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Discover Content",
    description:
      "Find inspiration, explore new photos, videos, and trending topics about Arts & Entertainment from around the world.",
  },
  {
    icon: <FaCloudUploadAlt className="text-[#30D5C8] w-10 h-10 mb-4" />,
    title: "Unlimited Uploads",
    description:
      "Store and upload as many photos and videos as you want, hassle-free.",
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 bg-white">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-bold text-[#30D5C8] mb-6">Our Features</h2>
        <p className="text-gray-500 mb-12 px-4 lg:px-0">
          Explore the amazing features that make our platform unique.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 px-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 bg-white shadow-lg rounded-lg flex flex-col items-center text-center"
            >
              {feature.icon}
              <h3 className="text-2xl font-semibold text-gray-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
